export const auth_config = {
  base: window.env.SVC_QUESTIONNAIRES_BASE_URL,
  validatePath: `${window.env.SVC_AUTH_BASE_URL}/api/v1/validate`,
}
